// ─── Auth (/api/v1/auth) ──────────────────────────────────────────────────────
export const API_AUTH_LOGIN_ROUTE = "/api/v1/auth/login";
export const API_AUTH_REFRESH_ROUTE = "/api/v1/auth/refresh";
export const API_AUTH_LOGOUT_ROUTE = "/api/v1/auth/logout";
export const API_AUTH_ME_ROUTE = "/api/v1/auth/me";
export const API_AUTH_PROFILE_ROUTE = "/api/v1/auth/profile";

// Registration requests
export const API_REGISTRATION_REQUESTS_ROUTE = "/api/v1/registration-requests";
export const API_ADMIN_REGISTRATION_REQUESTS_ROUTE =
  "/api/v1/admin/registration-requests";
export const API_ADMIN_REGISTRATION_REQUEST_ROUTE = (id: number) =>
  `${API_ADMIN_REGISTRATION_REQUESTS_ROUTE}/${id}`;
export const API_ADMIN_REGISTRATION_REQUEST_APPROVE_ROUTE = (id: number) =>
  `${API_ADMIN_REGISTRATION_REQUEST_ROUTE(id)}/approve`;
export const API_ADMIN_REGISTRATION_REQUEST_REJECT_ROUTE = (id: number) =>
  `${API_ADMIN_REGISTRATION_REQUEST_ROUTE(id)}/reject`;
export const API_ADMIN_REGISTRATION_REQUEST_RESEND_EMAIL_ROUTE = (id: number) =>
  `${API_ADMIN_REGISTRATION_REQUEST_ROUTE(id)}/resend-account-email`;
export const API_ADMIN_ACCESS_LOGS_ROUTE = "/api/v1/admin/access-logs";

// Fale Conosco
export const API_CONTACT_REQUESTS_ROUTE = "/api/v1/contact-requests";
export const API_PLATFORM_EVALUATIONS_ROUTE = "/api/v1/platform-evaluations";

// ─── Users (/api/v1/users) ────────────────────────────────────────────────────
export const API_USERS_ME_ROUTE = "/api/v1/users/me";
export const API_USERS_AUTH_INFO_ROUTE = "/api/v1/users/auth-info";

// ─── Permissions (/api/v1/permissions) ───────────────────────────────────────
export const API_ROLES_ROUTE = "/api/v1/permissions/roles";
export const API_PERMISSIONS_ME_ROUTE = "/api/v1/permissions/me";
export const API_PERMISSIONS_FEATURES_ROUTE = "/api/v1/permissions/features";

// ─── Solar Report (/api/v1/report) ────────────────────────────────────────────
export const API_SOLAR_REPORT_ROUTE = "/api/v1/report";
export const API_SOLAR_DISTRIBUTION_ROUTE = "/api/v1/report/distribution";
export const API_STATE_STATS_ROUTE = "/api/v1/report/state-stats";

// ─── Wind Report (/api/v1/report) ────────────────────────────────────────────
export const API_WIND_SERIES_ROUTE = "/api/v1/report/wind-series";
export const API_WIND_DENSITY_ROUTE = "/api/v1/report/wind-density";
export const API_WIND_DISTRIBUTION_ROUTE = "/api/v1/report/wind-distribution";
export const API_WIND_POTENTIAL_ROUTE = "/api/v1/report/wind-potential";
export const API_WIND_CUMULATIVE_ROUTE = "/api/v1/report/wind-cumulative";
export const API_AREA_POTENTIAL_ROUTE = "/api/v1/report/area-potential";
export const API_AREA_WIND_POTENTIAL_ROUTE =
  "/api/v1/report/area-wind-potential";
export const API_WIND_ROSE_ROUTE = "/api/v1/report/wind-speed/rose";

// ─── Geocoding (/api/v1/geocoding) ───────────────────────────────────────────
export const API_GEOCODING_FORWARD_ROUTE = "/api/v1/geocoding/forward";
export const API_GEOCODING_REVERSE_ROUTE = "/api/v1/geocoding/reverse";

// ─── Legend stats (/api/v1/report) ───────────────────────────────────────────
export const API_REPORT_RASTER_STATS_ROUTE = "/api/v1/report/raster-stats";
export const API_REPORT_REGION_AREA_ROUTE = "/api/v1/report/region-area";
export const API_GENERATION_POWER_SUMMARY_ROUTE =
  "/api/v1/report/generation-power-summary";
export const API_PROJECTION_AREA_STATS_ROUTE =
  "/api/v1/report/projection-area-stats";
export const API_RESTRICTION_BREAKDOWN_ROUTE =
  "/api/v1/report/restriction-breakdown";
export const API_REPORT_LEGEND_COUNTS_ROUTE = "/api/v1/report/legend-counts";
export const API_RESOURCE_CHARACTERIZATION_ROUTE =
  "/api/v1/report/resource-characterization";

// ─── Geospatial (/api/v1/geo) ─────────────────────────────────────────────────
export const API_DISTANCE_TO_LAYER_ROUTE = "/api/v1/geo/distance-to-layer";

// ─── Propitious area jobs (/api/v1/propitious-area-jobs) ─────────────────────
export const API_PROPITIOUS_AREA_JOBS_ROUTE = "/api/v1/propitious-area-jobs";
export const API_PROPITIOUS_AREA_JOB_ROUTE = (id: number) =>
  `${API_PROPITIOUS_AREA_JOBS_ROUTE}/${id}`;

// ─── Legacy (backend anterior — rotas não existem no backend atual) ───────────
// TODO: as páginas UserEnable e InviteUser usam estas rotas e estão quebradas.
// Mapear para os novos endpoints quando disponíveis.
export const API_USER_ROUTE = "/user";
export const API_USER_ENABLE_ROUTE = `${API_USER_ROUTE}/enable`;
export const API_USER_SEND_EMAIL_CHANGE_PASSWORD_ROUTE = `${API_USER_ROUTE}/sendEmailChangePassword`;
export const API_USER_CHANGE_PASSWORD_ROUTE = `${API_USER_ROUTE}/changePassword`;
export const API_OAUTH_ROUTE = "/oauth";
export const API_METADATA_ROUTE = "/api/metadata";
export const API_DETAIL_METADATA_ROUTE = (id: string) =>
  `${API_METADATA_ROUTE}/${id}`;
export const API_CATEGORY_METADATA_ROUTE = (id: string) =>
  `${API_METADATA_ROUTE}/category/${id}`;
export const API_PROFILE_ROUTE = "/profile";
export const API_USER_INVITATE_ROUTE = `${API_USER_ROUTE}/sendInvation`;
